<style></style>
<template>
  <div
    id="app"
    :class="{'container has-boxed-layout':isLayoutBoxed}"
  >
    <nav-bar/>
    <aside-menu
      :menu="menu"
      :menu-bottom="menuBottom"
      :class="{'has-secondary':!!menuSecondary}"
      @menu-click="menuClick"
    />
    <aside-menu
      v-if="menuSecondary"
      :menu="menuSecondary"
      is-secondary
      :label="menuSecondaryLabel"
      :icon="menuSecondaryIcon"
      @menu-click="menuClick"
      @close="menuSecondaryClose"
    />
    <div class="p-4">
      <flash-messages></flash-messages>
      <slot/>
    </div>
    <aside-right/>
    <footer-bar/>
    <overlay-layer @overlay-click="overlayClick"/>
  </div>
</template>

<script>
// import '@/../scss/style-light-dark.scss'
import '@/../scss/style-default.scss'
import {adminMenu as menu, menuBottom} from '@/menu.js'
import NavBar from '@/Shared/NavBar.vue'
import AsideMenu from '@/Shared/AsideMenu.vue'
import FooterBar from '@/Shared/FooterBar.vue'
import OverlayLayer from '@/Shared/OverlayLayer.vue'
import AsideRight from '@/Shared/AsideRight.vue'
import {mapState} from 'vuex'
import FlashMessages from "@/Shared/FlashMessages";

export default {
  name: 'App',
  props: {
    auth: Object,
  },
  components: {
    AsideRight,
    OverlayLayer,
    FooterBar,
    FlashMessages,
    AsideMenu,
    NavBar
  },
  data() {
    return {
      menu,
      menuBottom,
      menuSecondary: null,
      menuSecondaryLabel: null,
      menuSecondaryIcon: null
    }
  },

  computed: {
    ...mapState([
      'isLayoutBoxed',
      'isLayoutAsideHidden',
      'isLayoutMobile'
    ])
  },
  watch: {
    isLayoutMobile(newVal) {
      if (newVal) {
        this.$store.commit('layoutBoxedToggle', false)
      }
    }
  },
  created() {
    this.$store.commit('layoutBoxedToggle', false)
    this.$store.commit('asideRightToggle', false)
    this.$store.commit('overlayToggle', false)
    this.$store.commit('asideStateToggle', true)
    // this.$store.dispatch('asideStateToggle', true)
    // this.$router.afterEach(() => {
    //   this.menuSecondary = null
    //   this.menuSecondaryLabel = null
    //   this.menuSecondaryIcon = null
    // })

    this.$store.commit('user', {
      name: 'John Doe',
      email: 'john@example.com',
      avatar: 'https://avatars.dicebear.com/api/avataaars/example.svg?options[top][]=shortHair&options[accessoriesChance]=93'
    })
  },
  mounted() {
    document.documentElement.classList.remove('has-spinner-active')
  },
  methods: {
    menuClick(item) {
      if (item.menuSecondary) {
        this.menuSecondary = item.menuSecondary
        this.menuSecondaryLabel = item.menuSecondaryLabel ?? null
        this.menuSecondaryIcon = item.menuSecondaryIcon ?? null

        this.$store.commit('asideActiveForcedKeyToggle', item)
        this.$store.commit('overlayToggle', true)
      } else if (item.action && item.action === 'logout') {
        this.$buefy.toast.open({
          message: 'Log out clicked',
          type: 'is-danger',
          queue: false
        })
      }
    },
    menuSecondaryClose() {
      this.menuSecondary = this.menuSecondaryLabel = this.menuSecondaryIcon = null

      this.$store.commit('asideActiveForcedKeyToggle', null)

      if (!this.isLayoutAsideHidden) {
        this.$store.commit('overlayToggle', false)
      }
    },
    overlayClick() {
      if (this.menuSecondary) {
        this.menuSecondaryClose()
      } else {
        this.$store.dispatch('asideCloseAll')
      }
    }
  },
}
</script>
